<template>
  <t-config-provider>
    <router-view :class="[mode]" />
  </t-config-provider>
</template>
<script setup lang="ts">
import { computed } from 'vue';

import { useSettingStore } from '@/store';

import pgk from '../package.json';

const store = useSettingStore();

const mode = computed(() => {
  return store.displayMode;
});

console.log(
  `%c\n 建交云招采服务支撑平台 V${pgk.version} %c  \n`,
  'color: #ffffff; background: #0052d9; padding:5px 0; border-radius: 5px;',
  'color: #ffffff;',
);
</script>
<style lang="less" scoped>
#nprogress .bar {
  background: var(--td-brand-color) !important;
}
</style>
